/*=========================================================================================
  File Name: module-auth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from "./module-user-setting-state";
import mutations from "./module-user-setting-mutations";
import actions from "./module-user-setting-actions";
import getters from "./module-user-setting-getters";

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
